import { SidebarContainer } from "../../../assets/StyledComponent/Input/Input.Style";
import { NavLink } from "react-router-dom";
import Iconbutton from "../../../components/Iconbutton/Iconbutton";
import { MdInsertComment, MdGroupAdd } from "react-icons/md";
import { MdFastfood } from "react-icons/md";

// MdInsertComment
import { BsFillPeopleFill } from "react-icons/bs";
import { BsFillPersonPlusFill } from "react-icons/bs";
import { ImHome } from "react-icons/im";
const AdminDrawer = () => {
  // const [state, dispatch]: any = useStore();

  return (
    <SidebarContainer className="w-100">
      <div className="ps-2 mb-3 title">Home</div>

      <NavLink to="/admin/dashboard" style={{ textDecoration: "none" }}>
        {({ isActive }) => (
          <Iconbutton
            icon={<ImHome />}
            title="Home"
            style={isActive ? "active" : "text-decoration-none"}
          />
        )}
      </NavLink>

      <div className="ps-2 my-3 title">EMPLOYEE CONTROL</div>

      <NavLink to="/admin/viewemployee" end style={{ textDecoration: "none" }}>
        {({ isActive }) => (
          <Iconbutton
            icon={<BsFillPeopleFill />}
            title="View Employee"
            style={isActive ? "active" : "text-decoration-none"}
          />
        )}
      </NavLink>

      <NavLink
        to="/admin/createemployee"
        end
        style={{ textDecoration: "none" }}
      >
        {({ isActive }) => (
          <Iconbutton
            icon={<BsFillPersonPlusFill />}
            title="Creat Employee"
            style={isActive ? "active" : "text-decoration-none"}
          />
        )}
      </NavLink>
      <NavLink
        to="/admin/bulk-Employee-Add"
        end
        style={{ textDecoration: "none" }}
      >
        {({ isActive }) => (
          <Iconbutton
            icon={<MdGroupAdd />}
            title="Bulk Add"
            style={isActive ? "active" : "text-decoration-none"}
          />
        )}
      </NavLink>

      {/* <div className="ps-2 my-3 title">REPORT</div>

      <NavLink to="/admin/expensereport" end style={{ textDecoration: "none" }}>
        {({ isActive }) => (
          <Iconbutton
            icon={<MdInsertComment />}
            title="Expense Report"
            style={isActive ? "active" : "text-decoration-none"}
          />
        )}
      </NavLink> */}

      <div className="ps-2 my-3 title">ORDER FOOD</div>

      <NavLink to="/userdashboard" end style={{ textDecoration: "none" }}>
        {({ isActive }) => (
          <Iconbutton
            icon={<MdFastfood />}
            title="Order Food"
            style={isActive ? "active" : "text-decoration-none"}
          />
        )}
      </NavLink>

      <div className="ps-2 my-3 title">REPORT</div>
      {/* 
      <NavLink
        to="/admin/employee-Expense-Report"
        end
        style={{ textDecoration: "none" }}
      >
        {({ isActive }) => (
          <Iconbutton
            icon={<MdInsertComment />}
            title="Employee"
            style={isActive ? "active" : "text-decoration-none"}
          />
        )}
      </NavLink> */}

      <NavLink
        to="/admin/sytemfoodreport"
        end
        style={{ textDecoration: "none" }}
      >
        {({ isActive }) => (
          <Iconbutton
            icon={<MdInsertComment />}
            title="Report"
            style={isActive ? "active" : "text-decoration-none"}
          />
        )}
      </NavLink>

      {/* <NavLink
        to="/admin/adminuserreport"
        end
        style={{ textDecoration: "none" }}
      >
        {({ isActive }) => (
          <Iconbutton
            icon={<MdInsertComment />}
            title="User Report"
            style={isActive ? "active" : "text-decoration-none"}
          />
        )}
      </NavLink> */}
      {/* <div className="accordion accordion-flush" id="accordionFlushExample">
        <div className="accordion-item">
          <div
            className=" w-100"
            data-bs-toggle="collapse"
            data-bs-target="#flush-collapseOne"
          >
            <Iconbutton icon={<MdMenuBook />} title="Employee" isDropdown />
          </div>
          <div
            id="flush-collapseOne"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="suboption ">
              <NavLink to="/admin/createemployee" className={({ isActive }) =>
                        isActive ? "profile_Link_act" : "linkText"
                      }>Create Employee</NavLink>
              <NavLink to="/admin/viewemployee" className={({ isActive }) =>
                        isActive ? "profile_Link_act" : "linkText"
                      }>
                View Employee
              </NavLink>
            </div>
          </div>
        </div>
      </div> */}
    </SidebarContainer>
  );
};

export default AdminDrawer;
